import React, { lazy } from 'react';

const CompleteDocUpload = lazy(() =>
  import(
    '|/app/steps/complete-doc-upload' /* webpackChunkName: "complete-doc-upload" */
  )
);

const defaultProps = {
  GetDashboardAndRouteToNextStep: (_?: boolean) => {}
};

export const CompleteDocUploadRoute = ({
  GetDashboardAndRouteToNextStep
} = defaultProps) => {
  return (
    <CompleteDocUpload
      GetDashboardAndRouteToNextStep={GetDashboardAndRouteToNextStep}
    />
  );
};
